var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHanddesinfektion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54.616,
    height: 54.616,
    viewBox: "0 0 54.616 54.616",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_123",
    x: 0,
    y: 0,
    width: 54.616,
    height: 54.616,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#57b0b6",
    floodOpacity: 0.298
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "handdesinfektion",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Pfad_123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_123-2",
    "data-name": "Pfad 123",
    d: "M106.616,72.308A18.308,18.308,0,1,0,88.308,90.616a18.308,18.308,0,0,0,18.308-18.308",
    transform: "translate(-61 -48)",
    fill: "#dbf1f7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_124",
    "data-name": "Pfad 124",
    d: "M138.776,264.677h-2.248a.842.842,0,0,1-.843-.843,1.405,1.405,0,0,1,1.4-1.4h-2.248a.842.842,0,0,1-.843-.843,1.405,1.405,0,0,1,1.4-1.4h1.124a.842.842,0,0,1-.843-.843,1.405,1.405,0,0,1,1.4-1.4h8.642s-3.866-1.4-3.866-2.81c0-.7.421-1.124.877-1.124.354,0,2.529.967,3.619,1.124a15.666,15.666,0,0,1,7.271,2.422c.714.421,1.579,1.511,2.843,1.511h2.248v6.181H156.2a6.888,6.888,0,0,0-2.708.556l-1.337.573a6.888,6.888,0,0,1-2.708.556H138.214a.842.842,0,0,1-.843-.843,1.405,1.405,0,0,1,1.4-1.4",
    transform: "translate(-123.121 -236.135)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_125",
    "data-name": "Pfad 125",
    d: "M267.619,76.181c0,1.944-.938,2.81-2.81,2.81s-2.81-.865-2.81-2.81S264.81,70,264.81,70s2.81,4.237,2.81,6.181",
    transform: "translate(-242.13 -65.06)",
    fill: "#73c9e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_126",
    "data-name": "Pfad 126",
    d: "M97.933,8.748c-.455.034-.843.061-1.124.061a7.015,7.015,0,0,1-1.124-.1A7.487,7.487,0,0,1,94,8.248V6.562a7.687,7.687,0,0,0,2.81.562c1.315,0,5.479-1.124,7.867-1.124a11.44,11.44,0,0,1,3.933,1.124L107.486,8.81a12.682,12.682,0,0,0-3.372-.562c-1.877,0-4.507.348-6.181.5",
    transform: "translate(-85.93 -5.555)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_127",
    "data-name": "Pfad 127",
    d: "M26.724,198.429H18.081a1.405,1.405,0,0,0-1.4,1.4.842.842,0,0,0,.843.843H16.4a1.405,1.405,0,0,0-1.4,1.4.842.842,0,0,0,.843.843h2.248a1.405,1.405,0,0,0-1.4,1.4.842.842,0,0,0,.843.843h2.248a1.405,1.405,0,0,0-1.4,1.4.842.842,0,0,0,.843.843h4.776v1.686a1.683,1.683,0,0,1-1.686,1.686H7.686A1.683,1.683,0,0,1,6,209.105V194.13a2.242,2.242,0,0,1,1.158-1.961l3.9-2.169h7.867l3.9,2.169a1.993,1.993,0,0,1,.416.3,2.937,2.937,0,0,1,.494,2.028c-.455,0-.877.421-.877,1.124,0,1.4,3.866,2.81,3.866,2.81",
    transform: "translate(-4.111 -176.631)",
    fill: "#73c9e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_128",
    "data-name": "Pfad 128",
    d: "M85.867,126v4.5H78V126h7.867Z",
    transform: "translate(-71.054 -117.126)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_129",
    "data-name": "Pfad 129",
    d: "M106.5,86v2.81H102V86h4.5Z",
    transform: "translate(-93.368 -79.936)",
    fill: "#73c9e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_130",
    "data-name": "Pfad 130",
    d: "M120.248,44.675v2.871H118V44.641a7.015,7.015,0,0,0,1.124.1c.281,0,.669-.028,1.124-.061",
    transform: "translate(-108.244 -41.482)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_131",
    "data-name": "Pfad 131",
    d: "M183.165,336.843h-6.743a.421.421,0,1,1,0-.843h6.743a.421.421,0,1,1,0,.843",
    transform: "translate(-162.17 -312.376)",
    fill: "#303e58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_132",
    "data-name": "Pfad 132",
    d: "M153.264,307.091A1.266,1.266,0,0,1,152,305.826,1.828,1.828,0,0,1,153.826,304h9.834a.421.421,0,1,1,0,.843h-9.834a.984.984,0,0,0-.983.983.422.422,0,0,0,.421.421.421.421,0,1,1,0,.843",
    transform: "translate(-139.856 -282.624)",
    fill: "#303e58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_133",
    "data-name": "Pfad 133",
    d: "M138.536,339.091h-9.272A1.266,1.266,0,0,1,128,337.826,1.828,1.828,0,0,1,129.826,336h1.967a.421.421,0,1,1,0,.843h-1.967a.984.984,0,0,0-.983.983.422.422,0,0,0,.421.421h9.272a.421.421,0,0,1,0,.843",
    transform: "translate(-117.542 -312.376)",
    fill: "#303e58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_134",
    "data-name": "Pfad 134",
    d: "M160.85,371.091h-7.586A1.266,1.266,0,0,1,152,369.826,1.828,1.828,0,0,1,153.826,368a.421.421,0,1,1,0,.843.984.984,0,0,0-.983.983.422.422,0,0,0,.421.421h7.586a.421.421,0,1,1,0,.843",
    transform: "translate(-139.856 -342.128)",
    fill: "#303e58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_135",
    "data-name": "Pfad 135",
    d: "M188.5,403.091H177.264A1.266,1.266,0,0,1,176,401.826,1.828,1.828,0,0,1,177.826,400a.421.421,0,0,1,0,.843.984.984,0,0,0-.983.983.422.422,0,0,0,.421.421H188.5a6.428,6.428,0,0,0,2.543-.522l1.337-.573a7.266,7.266,0,0,1,2.874-.591h2.523a.421.421,0,1,1,0,.843h-2.523a6.428,6.428,0,0,0-2.543.522l-1.337.573a7.266,7.266,0,0,1-2.874.591",
    transform: "translate(-162.17 -371.88)",
    fill: "#303e58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_136",
    "data-name": "Pfad 136",
    d: "M257.279,253.9h-2.248a3.96,3.96,0,0,1-2.469-1.133,5.6,5.6,0,0,0-.589-.436,14.84,14.84,0,0,0-6.717-2.31l-.4-.058a15.184,15.184,0,0,1-2.5-.76,11.069,11.069,0,0,0-1.071-.359c-.218.007-.446.252-.446.7,0,.756,2.141,1.887,3.589,2.414a.421.421,0,0,1-.288.792,16.267,16.267,0,0,1-1.991-.9c-1.449-.79-2.153-1.542-2.153-2.3A1.4,1.4,0,0,1,241.3,248a5.354,5.354,0,0,1,1.351.41,14.808,14.808,0,0,0,2.328.718l.4.058A15.517,15.517,0,0,1,252.4,251.6a6.151,6.151,0,0,1,.689.506,3.255,3.255,0,0,0,1.941.947h2.248a.421.421,0,1,1,0,.843",
    transform: "translate(-221.675 -230.557)",
    fill: "#303e58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_137",
    "data-name": "Pfad 137",
    d: "M80.288,125.338H72.421a.421.421,0,0,1,0-.843h7.445v-3.652H72.843v1.826a.421.421,0,1,1-.843,0v-2.248a.422.422,0,0,1,.421-.421h7.867a.422.422,0,0,1,.421.421v4.5a.422.422,0,0,1-.421.421",
    transform: "translate(-65.476 -111.548)",
    fill: "#303e58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_138",
    "data-name": "Pfad 138",
    d: "M100.917,83.653a.422.422,0,0,1-.421-.421V80.843H96.843v.7a.421.421,0,0,1-.843,0V80.421A.422.422,0,0,1,96.421,80h4.5a.422.422,0,0,1,.421.421v2.81a.422.422,0,0,1-.421.421",
    transform: "translate(-87.79 -74.357)",
    fill: "#303e58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_139",
    "data-name": "Pfad 139",
    d: "M144.421,42.534a.422.422,0,0,1-.421-.421V39.218a.421.421,0,1,1,.843,0v2.894a.422.422,0,0,1-.421.421",
    transform: "translate(-132.418 -36.048)",
    fill: "#303e58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_140",
    "data-name": "Pfad 140",
    d: "M112.421,42.389a.422.422,0,0,1-.421-.421V39.062a.421.421,0,1,1,.843,0v2.905a.422.422,0,0,1-.421.421",
    transform: "translate(-102.666 -35.903)",
    fill: "#303e58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_141",
    "data-name": "Pfad 141",
    d: "M101.908,3.653a.42.42,0,0,1-.13-.021,12.342,12.342,0,0,0-3.241-.541c-1.363,0-3.112.185-4.654.348-.538.057-1.047.111-1.489.151h-.007c-.438.032-.851.063-1.155.063a7.432,7.432,0,0,1-1.191-.1,7.877,7.877,0,0,1-1.79-.5A.422.422,0,0,1,88,2.669V.983A.422.422,0,0,1,88.593.6a7.333,7.333,0,0,0,2.638.526A21.53,21.53,0,0,0,94.026.693,31.11,31.11,0,0,1,99.1,0a11.708,11.708,0,0,1,4.119,1.167.421.421,0,0,1,.165.612l-1.124,1.686a.422.422,0,0,1-.351.188M88.843,2.381a7.6,7.6,0,0,0,1.331.339h0a6.593,6.593,0,0,0,1.056.09c.272,0,.669-.029,1.089-.06s.939-.093,1.473-.149c1.564-.165,3.336-.353,4.743-.353a12.639,12.639,0,0,1,3.194.491l.676-1.014A9.77,9.77,0,0,0,99.1.843a30.63,30.63,0,0,0-4.915.679,20.991,20.991,0,0,1-2.952.445,8.112,8.112,0,0,1-2.388-.382Z",
    transform: "translate(-80.352 0.023)",
    fill: "#303e58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_142",
    "data-name": "Pfad 142",
    d: "M16.717,205.633H2.107A2.11,2.11,0,0,1,0,203.525V188.55a2.662,2.662,0,0,1,1.375-2.33l3.9-2.168a.421.421,0,1,1,.41.737l-3.9,2.169a1.82,1.82,0,0,0-.941,1.593v14.975a1.266,1.266,0,0,0,1.264,1.264h14.61a1.266,1.266,0,0,0,1.264-1.264.421.421,0,1,1,.843,0,2.11,2.11,0,0,1-2.107,2.107",
    transform: "translate(1.467 -171.051)",
    fill: "#303e58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_143",
    "data-name": "Pfad 143",
    d: "M188.32,187.01a.42.42,0,0,1-.2-.053l-3.9-2.169a.421.421,0,0,1,.41-.737l3.9,2.169a.422.422,0,0,1-.205.79",
    transform: "translate(-169.608 -171.051)",
    fill: "#303e58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_144",
    "data-name": "Pfad 144",
    d: "M259.231,73.834c-2.144,0-3.231-1.087-3.231-3.231,0-2.048,2.762-6.237,2.88-6.414a.421.421,0,0,1,.7,0c.118.177,2.88,4.366,2.88,6.414,0,2.144-1.087,3.231-3.231,3.231m0-8.631c-.891,1.43-2.388,4.1-2.388,5.4,0,1.674.714,2.388,2.388,2.388s2.388-.714,2.388-2.388c0-1.3-1.5-3.97-2.388-5.4",
    transform: "translate(-236.551 -59.481)",
    fill: "#303e58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_145",
    "data-name": "Pfad 145",
    d: "M280.455,154.972h-.019a1.606,1.606,0,0,1-.97-.388l-.009-.008a1.576,1.576,0,0,1-.49-.877.421.421,0,0,1,.829-.151.728.728,0,0,0,.224.4.759.759,0,0,0,.453.181.421.421,0,0,1-.018.842",
    transform: "translate(-257.898 -142.418)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHanddesinfektion);
export default __webpack_public_path__ + "static/media/handdesinfektion.22a9b7d489b9142776badb8e4c618100.svg";
export { ForwardRef as ReactComponent };